<template>
  <div class="row g-4">
    <div class="col-12">
      <div class="form-field">
        <label class="field-label">شارة أعلى القسم</label>
        <InputText v-model="local.badge_text" class="w-100" />
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field">
        <label class="field-label">اسم الأستاذ (للزائر)</label>
        <InputText v-model="local.name_guest" class="w-100" />
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field">
        <label class="field-label">اللقب</label>
        <InputText v-model="local.subtitle" class="w-100" />
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field">
        <label class="field-label">اللقب المختصر (شريط المعلم بالموبايل)</label>
        <InputText v-model="local.teacher_bar_subtitle" class="w-100" />
      </div>
    </div>
    <div class="col-12">
      <div class="form-field">
        <label class="field-label">الوصف (للزائر)</label>
        <Textarea v-model="local.description_guest" rows="3" class="w-100" />
      </div>
    </div>
    <div class="col-12">
      <div class="form-field">
        <label class="field-label">الوصف (للطالب المسجل)</label>
        <Textarea v-model="local.description_auth" rows="2" class="w-100" />
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field">
        <label class="field-label">رابط واتساب</label>
        <InputText v-model="local.whatsapp_url" class="w-100" placeholder="https://wa.me/+2010..." />
      </div>
    </div>
    <div class="col-lg-3 col-6">
      <div class="form-field">
        <label class="field-label">نص زر واتساب (ديسكتوب)</label>
        <InputText v-model="local.whatsapp_label" class="w-100" />
      </div>
    </div>
    <div class="col-lg-3 col-6">
      <div class="form-field">
        <label class="field-label">نص زر واتساب (موبايل)</label>
        <InputText v-model="local.whatsapp_label_mobile" class="w-100" />
      </div>
    </div>
    <div class="col-12">
      <div class="form-field">
        <label class="field-label">نص التواجد الاجتماعي</label>
        <InputText v-model="local.social_proof_text" class="w-100" />
      </div>
    </div>

    <div class="col-lg-6 col-12">
      <div class="form-field">
        <label class="field-label">زر رئيسي (طالب مسجل)</label>
        <div class="stat-row">
          <InputText v-model="local.cta_auth_primary.label" placeholder="النص" class="w-100" />
          <InputText v-model="local.cta_auth_primary.link" placeholder="الرابط" class="w-100" />
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field">
        <label class="field-label">زر ثانوي (طالب مسجل)</label>
        <div class="stat-row">
          <InputText v-model="local.cta_auth_secondary.label" placeholder="النص" class="w-100" />
          <InputText v-model="local.cta_auth_secondary.link" placeholder="الرابط" class="w-100" />
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-field">
        <label class="field-label">صورة الأستاذ <span class="optional">اختياري</span></label>
        <img v-if="currentAvatarLink && !avatarFile" :src="currentAvatarLink" alt="" class="current-image-preview mb-2" />
        <div :class="['upload-zone', { 'upload-zone--has-file': avatarFile }]">
          <div class="upload-zone__icon"><i :class="`pi ${avatarFile ? 'pi-check' : 'pi-cloud-upload'}`"></i></div>
          <p class="upload-zone__label">{{ avatarFile ? avatarFile.name : 'اضغط لاختيار صورة' }}</p>
          <input type="file" accept="image/*" @change="onAvatarChange" />
        </div>
      </div>
    </div>

    <div class="col-12">
      <label class="field-label d-block mb-2">الإحصائيات (حتى 3)</label>
      <div v-for="(stat, idx) in local.stats" :key="idx" class="answer-item">
        <div class="answer-item__index">{{ idx + 1 }}</div>
        <div class="answer-item__content">
          <div class="stat-row stat-row--3">
            <InputText v-model="stat.icon" placeholder="أيقونة (إيموجي)" class="w-100" />
            <InputText v-model="stat.number" placeholder="الرقم" class="w-100" />
            <InputText v-model="stat.label" placeholder="التسمية" class="w-100" />
          </div>
        </div>
        <div class="answer-item__actions">
          <button type="button" class="answer-remove-btn" @click="removeStat(idx)"><i class="pi pi-trash"></i></button>
        </div>
      </div>
      <button type="button" class="add-answer-btn" v-if="local.stats.length < 3" @click="addStat">
        <i class="pi pi-plus"></i> إضافة إحصائية
      </button>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch } from 'vue';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
  currentAvatarLink: { type: String, default: null },
});
const emit = defineEmits(['update:modelValue', 'update:avatarFile']);

const local = reactive({
  badge_text: props.modelValue.badge_text ?? '',
  name_guest: props.modelValue.name_guest ?? '',
  subtitle: props.modelValue.subtitle ?? '',
  teacher_bar_subtitle: props.modelValue.teacher_bar_subtitle ?? '',
  description_guest: props.modelValue.description_guest ?? '',
  description_auth: props.modelValue.description_auth ?? '',
  whatsapp_url: props.modelValue.whatsapp_url ?? '',
  whatsapp_label: props.modelValue.whatsapp_label ?? '',
  whatsapp_label_mobile: props.modelValue.whatsapp_label_mobile ?? '',
  social_proof_text: props.modelValue.social_proof_text ?? '',
  cta_auth_primary: { ...(props.modelValue.cta_auth_primary ?? { label: '', link: '' }) },
  cta_auth_secondary: { ...(props.modelValue.cta_auth_secondary ?? { label: '', link: '' }) },
  stats: (props.modelValue.stats ?? []).map((s) => ({ ...s })),
});

const avatarFile = ref(null);

watch(local, () => emit('update:modelValue', { ...props.modelValue, ...local }), { deep: true });

function addStat() {
  if (local.stats.length < 3) local.stats.push({ icon: '', number: '', label: '' });
}
function removeStat(idx) {
  local.stats.splice(idx, 1);
}
function onAvatarChange(e) {
  avatarFile.value = e.target.files[0] || null;
  emit('update:avatarFile', avatarFile.value);
}
</script>

<style scoped>
.stat-row { display: grid; grid-template-columns: 1fr 1fr; gap: .5rem; }
.stat-row--3 { grid-template-columns: 80px 1fr 1fr; }
</style>
